import { render } from "./index.html?vue&type=template&id=c8feeaae"
import script from "./index-center.vue?vue&type=script&lang=js"
export * from "./index-center.vue?vue&type=script&lang=js"

import "./index-center.vue?vue&type=style&index=0&id=c8feeaae&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-search-bar/template1/index-center.vue'],['render',render],['__file',"index-center.vue"]])

export default __exports__